import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefaultComponent } from './layouts/default/default.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { ClassComponent } from './modules/class/class.component';
import { ExamComponent } from './modules/exam/exam.component';
import { StudentComponent } from './modules/student/student.component';
import { QuestionBankComponent } from './modules/question-bank/question-bank.component';
import { AppSettingsComponent } from './modules/app-settings/app-settings.component';

const routes: Routes = [{
  path: '',
  component: DefaultComponent,
  children: [
  {
    path: '',
    component: DashboardComponent
  }, 
  {
    path: 'class',
    component: ClassComponent
  },
  {
    path: 'exam',
    component: ExamComponent
  },
  {
    path: 'student',
    component: StudentComponent
  },
  {
    path: 'question-bank',
    component: QuestionBankComponent
  },
  {
    path: 'app-settings',
    component: AppSettingsComponent
  }
]
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
